import {
  Suspense,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import GlobalLoader from "../../../components/Common/GlobalLoader";
import { useTranslation } from "react-i18next";
import TableContainer from "../../../components/Common/TableContainer";
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "reselect";
import {
  getPharmacistSaleReports as onGetPharmacistSaleReports,
  getPharmacistSaleReportsDetails as onGetPharmacistSaleReportsDetails,
} from "../../../slice/thunks";
import { Badge, Button, Col, Label, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import moment from "moment";
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import { useReactToPrint } from 'react-to-print'
import PrintHeader from "../../../components/Global/PrintHeader";
import { useProfile } from "../../../components/Hooks/UserHooks";

export default function MySales() {
  const props = useTranslation();
  const dispatch = useDispatch();
  const selectLayoutState = (state) => state.Settings;
  const [modal, setModal] = useState(false);
  const [target, setTarget] = useState("");
  const [periods, setPeriods] = useState(null);
  const fp = useRef(null);

  const SettingsProperties = createSelector(selectLayoutState, (setting) => ({
    pharmacistSalesReports: setting.pharmacistSalesReports,
    pharmacistSalesReportsDetails: setting.pharmacistSalesReportsDetails,
  }));

  const { pharmacistSalesReports, pharmacistSalesReportsDetails } =
    useSelector(SettingsProperties);

  useEffect(() => {
    console.log("dispatching...");
    dispatch(onGetPharmacistSaleReports({date: periods||moment().format("YYYY-MM-DD")}));
  }, [dispatch, periods]);

  const getPharmacistSaleReportsDetails = (target) => {
    dispatch(onGetPharmacistSaleReportsDetails({id: target, date: periods||moment().format("YYYY-MM-DD")}));
  };
   const printLayoutRef = useRef();
    const handlePrint = useReactToPrint({
      content: () => printLayoutRef.current,
    });

 

  const columns = useMemo(
    () => [
      {
        header: props.t("no"),
        cell: ({ row }) => <span>{row.index + 1}</span>,
      },
      {
        header: props.t("products_name"),
        cell: ({ row }) => (
          <span
            className=" fw-bold"
            style={{ cursor: "pointer" }}
            onClick={() => {
              setModal(!modal);
              getPharmacistSaleReportsDetails(row.original.productId);
            }}>
            {row.original.productName}
          </span>
        ),
        //accessorKey: "product_name",
      },
      {
        header: props.t("qty_sold"),
        //accessorKey: "quantity_sold",
        cell: ({ row }) => <span>{row.original.qtySold}</span>,
      },
      {
        header: props.t("unite_price"),
        //accessorKey: "unit_price",
        cell: ({ row }) => <span>{row.original.unitPrice}</span>,
      },
      {
        header: props.t("total_price"),
        //accessorKey: "total_price",
        cell: ({ row }) => <span>{row.original.totalAmount}</span>,
      },
    ],
    [props],
  );

  return (
    <Suspense fallback={<GlobalLoader />}>
      <div className="heading align-middle p-4">
        <h4>{props.t("my_Sales")}</h4>
        <div className="py-3 d-flex justify-content-between">
          <Col xl={2} sm={4} className="">
            <Label for="inputGroupSelect01"> {props.t("Pick_date")}: </Label>
            <Flatpickr
              className="flatpick-custom"
              id="inputGroupSelect01"
              ref={fp}
              placeholder={props.t("select_date_range")}
              defaultValue={periods}
              value={periods}
              options={{
                altInput: true,
                altFormat: "d / m/ Y",
                maxDate: new Date(),
              }}
              onChange={(e) => {
                console.log("dateData:", moment(e[0]).format("YYYY-MM-DD"));
                setPeriods(moment(e[0]).format("YYYY-MM-DD"));
              }}
            />
          </Col>
          <Button
            color="primary"
            style={{ marginLeft: "10px" }}
            onClick={() => handlePrint()}>
            <i className="fas fa-print"></i>
            {props.t("print_report")}
          </Button>
        </div>
        <TableContainer columns={columns} data={pharmacistSalesReports || []} />
        <div className=" d-flex justify-content-end">
          <div className=" card p-2 w-25">
            <h5 className=" m-0">
              Grand Total:
              <b>
                {pharmacistSalesReports?.reduce((a, b) => a + b.totalAmount, 0)}
              </b>
            </h5>
          </div>
        </div>
        <div ref={printLayoutRef} className="P-2">
          <PrintLayout data={pharmacistSalesReports || []} columns={columns} date={periods} />
        </div>
        <DetailsModal
          setModal={setModal}
          modal={modal}
          data={pharmacistSalesReportsDetails}
          resetTarget={setTarget}
          props={props}
        />
      </div>
    </Suspense>
  );
}

const DetailsModal = ({ setModal, modal, data, resetTarget, props }) => {
	  const printDetailLayoutRef = useRef();
    const handlePrint = useReactToPrint({
      content: () => printDetailLayoutRef.current,
    });
  const columns = useMemo(() => [
    {
      header: props.t("no"),
      cell: ({ row }) => <span>{row.index + 1}</span>,
    },
    {
      header: props.t("qty_sold"),
      cell: ({ row }) => <span>{row.original.quantity}</span>,
    },
    {
      header: props.t("unite_price"),
      cell: ({ row }) => <span>{row.original.unitPrice}</span>,
    },
    {
      header: props.t("discount"),
      cell: ({ row }) => <span>{row.original.discount}</span>,
    },
    {
      header: props.t("Posted_to_ward"),
      cell: ({ row }) => (
        <span>
          {row.original.postedToWard ?
            <Badge color="success">Yes</Badge>
          : <Badge color="danger">No</Badge>}
        </span>
      ),
    },
    {
      header: props.t("total_price"),
      cell: ({ row }) => (
        <span>{row.original.finalPrice * row.original.quantity}</span>
      ),
    },
    {
      header: props.t("created_at"),
      cell: ({ row }) => (
        <span>
          {moment(row.original.createdAt).format("DD MMM, YYYY HH:mm")}
        </span>
      ),
    },
  ]);

  return (
    <Modal
      isOpen={modal}
      backdrop={"static"}
      scrollable={true}
      size="lg"
      fullscreen="lg">
      <ModalHeader
        toggle={() => {
          setModal(!modal);
          resetTarget("");
        }}>
        Sales Details
      </ModalHeader>
      <ModalBody>
        <div>
          <p className="m-0">Product Name</p>
          <h6 className="p-0">{data?.productName}</h6>
        </div>
        <hr />
        <p className=" fs-4">Sales Record</p>
        <TableContainer columns={columns} data={data?.lines || []} />
        <div ref={printDetailLayoutRef}>
          <PrintDetailsLayout data={data} columns={columns} />
        </div>
      </ModalBody>
      <ModalFooter>
        <Button
          color="primary"
          onClick={() => {
           handlePrint()
          }}>
          <i className="fas fa-print"></i>
          Print
        </Button>
      </ModalFooter>
    </Modal>
  );
};

const PrintDetailsLayout = ({ data, columns}) => {
	const username = localStorage.getItem("username");
  const role = localStorage.getItem("role");
  return (
    <div className="d-none d-print-block p-2 m-2">
      <PrintHeader />
      <div className=" d-flex justify-content-between">
        <div>
          <p className="m-0">Product Name</p>
          <h6 className="p-0">{data?.productName}</h6>
        </div>
        <div>
          <p className="m-0">By:</p>
          <h6 className="p-0">{username}</h6>
        </div>
        <div>
          <p className="m-0">Role</p>
          <h6 className="p-0">{role.split('"')[1]}</h6>
        </div>
      </div>
      <hr />
      <p className=" fs-4">Sales Record</p>
      <TableContainer columns={columns} data={data?.lines || []} />
      <hr />
      <div className=" d-flex justify-content-end">
        <div className=" p-2">
          <h5 className=" m-0">
            Grand Total:{"  "}
            <b>
              {data?.lines?.reduce((a, b) => a + (b.finalPrice * b.quantity), 0)}{" "}
              XAF
            </b>
          </h5>
        </div>
      </div>
      <hr />
    </div>
  );
};

const PrintLayout = ({ data, columns,date }) => {
const username=localStorage.getItem('username')
const role= localStorage.getItem('role')
	
  return (
    <div className="d-none d-print-block p-2">
      <div className="m-2">
        <PrintHeader />
        <p className=" fs-3 m-0 text-center">
          Sales Record For: {moment(date).format("ddd ,MMM Do YYYY")}{" "}
          {!data && new Date().toDateString()}
        </p>
        <p className=" fs-6 m-0 text-center">
          For: <b>{username}</b> the ({role.split('"')[1]})
        </p>
        <hr />
        <TableContainer columns={columns} data={data || []} />
        <hr />
        <div className=" d-flex justify-content-end">
          <div className=" p-2">
            <h5 className=" m-0">
              Grand Total:{"  "}
              <b>{data?.reduce((a, b) => a + b.totalAmount, 0)} XAF</b>
            </h5>
          </div>
        </div>
        <hr />
      </div>
    </div>
  );
};